import { SHARED_FILTERS } from './send-mail-stepper-shared-filters';

export const SEND_MAIL_STEPPER_FORWARD_FILTERS = {
  path: '/mailing/stepper/forward/:id',
  filters: SHARED_FILTERS
};